import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { map } from 'rxjs'

import { AuthStore } from '@yoshu-lib/core/auth/auth.store'

import { CenterlineAccessService } from '@coty/core/centerline-access.service'

/**
 * Keeps the centerline routes off-limits to users the feature is not for.
 *
 * Two rejections happen before any request goes out, because neither needs one:
 * a non-`datamodel_user` can never see a sheet, and the centerline belongs to
 * the site groups that own one (yoshu#2923, yoshu#2975) -- a deep link from a
 * site with no matrix used to land on another site's sheet and fail there
 * instead of being turned away.
 *
 * The remaining check keeps a member off a sheet they cannot load: the endpoints
 * already 404 for them (entity ACLs are enforced server-side), this only stops a
 * deep link parking them on a dead page and keeps the route consistent with the
 * hidden nav entry.
 */
export const centerlineGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore)
  const access = inject(CenterlineAccessService)
  const router = inject(Router)

  if (!authStore.hasGroup('datamodel_user') || !access.isCenterlineGroupMember()) {
    return router.createUrlTree(['/'])
  }

  return access.hasAccess$.pipe(map((hasAccess) => hasAccess || router.createUrlTree(['/'])))
}
